export interface IUser {
  id?: any;
  login?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  createdBy?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: any;
  createdDate?: any;
  password?: string;
  customers?: any[];
  employee?: any[];
  jalaliDate?: any;


}

export class User implements IUser {
  constructor(
    public id?: any,
    public jalaliDate?: any,
    public login?: string,
    public firstName?: string,
    public lastName?: string,
    public email?: string,
    public activated?: boolean,
    public langKey?: string,
    public authorities?: any[],
    public customers?: any[],
    public createdBy?: string,
    public lastModifiedBy?: string,
    public lastModifiedDate?: any,
    public createdDate?: any,
    public password?: string
  ) {
    this.id = id ? id : null;
    this.jalaliDate = jalaliDate ? jalaliDate : null;
    this.login = login ? login : null;
    this.firstName = firstName ? firstName : null;
    this.lastName = lastName ? lastName : null;
    this.email = email ? email : null;
    this.activated = activated ? activated : false;
    this.langKey = langKey ? langKey : null;
    this.authorities = authorities ? authorities : null;
    this.customers = customers ? customers : null;
    this.createdBy = createdBy ? createdBy : null;
    this.createdDate = createdDate ? createdDate : null;
    this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
    this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
    this.password = password ? password : null;
  }
}
